import { Button, Card, Input } from "@rumbledirect/ui";
import { Form } from "antd";

interface ServicePartnerCollectionDetailCardProps {
  isLoading?: boolean;
  submitting: boolean;
  title: string;
  buttonText: string;
}

export const ServicePartnerCollectionFormCard = ({
  isLoading = false,
  submitting,
  title,
  buttonText,
}: ServicePartnerCollectionDetailCardProps) => {
  return (
    <Card loading={isLoading} className="w-full" title={title}>
      <Form.Item
        rules={[{ required: true, message: "Dit veld is verplicht" }]}
        label="Naam"
        name="name"
      >
        <Input />
      </Form.Item>
      <Form.Item label="Beschrijving" name="description">
        <Input.TextArea />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting}>
          {buttonText}
        </Button>
      </Form.Item>
    </Card>
  );
};
